import React, {useEffect, useState, Fragment, useContext} from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {Button} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import {BaseUrl} from 'contexts/baseUrl/baseUrl';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import ErrModalPop from "components/sales/modal/errorModal";

const CampaignListing = ({
        history,
        getCampaignData,
        createInvoiceForCampaign,
        getCampaignListing = [],
        invoiceCreationAgainstCampaign = [],
        match
    }) => {
    const headers = [
        'Campaign Type',
        'Campaign Subtype',
        'Campaign Start Date',
        'Estimated Revenue',
        'Created By',
        'Created By Email',
        'Created At',
        'Status',
        'Invoice Number',
        'Actions',
    ];

    const filterInputs = {
        invoice_number: "",
    };
    const [listData, setListData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);
    const [isStatusSuccess, setIsStatusSuccess] = useState(false);
    const [isRoleId, setIsRoleId] = useState(null);
    const {baseUrl} = useContext(BaseUrl);
    const [invoiceValidationCompletePopup, setInvoiceValidationCompletePopup] = useState(false);
    const [campaignId, setCampaignId] = useState(false);
    const [formData, setFormData] = useState(filterInputs);
    const [invoiceCreation, setInvoiceCreation] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [isErrorModal, setIsErrorModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [roleId,setRoleId] = useState('');


    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getCampaignData(1, filterData)
            setIsLoading(false);
        })();
    }, []);

    useEffect(() => {
        setIsLoading(true);
        (async () => {
          if(localStorage.getItem('roles')){
            const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
            setRoleId(roles);
          }
         
        })();
        setIsLoading(false);
    }, []);

    useEffect(() => {
        const tableData = [
            'id',
            'campaign_type',
            'campaign_subtype',
            'start_date',
            'est_revenue',
            'name',
            'email',
            'created_at',
            'status_name',
            'invoice_number'
        ];

        if (getCampaignListing.data) {
            const data = getCampaignListing.data.map((element) =>
                Object.assign(
                    {},
                    ...tableData.map((key) => ({[key]: element[key]})),
                    (element.status === "4" || element.status === "3") ?
                    {
                        Action: [
                                {
                                    name: 'Create Invoice', 
                                    id: element.id,
                                },
                                {
                                    name: 'View Details', 
                                    link: `campaign-view`,
                                }
                        ]
                    } :
                    {
                        Action: [
                            {
                                name: 'View Details', 
                                link: `campaign-view`
                            }
                    ]
                        
                    }
                )
            );
            data && setListData(data);
            setPageCount(Math.ceil(getCampaignListing.total / getCampaignListing.per_page));
        }
    }, [getCampaignListing]);

    const applyFilter = async (filterData) => {
        localStorage.setItem("getCampaignListing", JSON.stringify(filterData));
        // console.log('filterData:',filterData);
        // return false;
        setIsLoading(true);
        setFilterData(filterData);
        await getCampaignData(1, filterData);
        setIsLoading(false);
        filterToggle();
    };

    // useEffect(() => {
    //     (async () => {
    //         await getListFilterData(2);
    //     })();
    // }, []);

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const handleApprovedModalHide = () => {
        setInvoiceValidationCompletePopup(false);
        history.goBack('');
    };

    const handleInvoiceCreationModalHide = () => {
        setInvoiceCreation(false);
        history.goBack('');
    };

    const handleModalHide1 = () => setIsErrorModal(false);
    const handleModalHide = () => setIsModal(false);

    const headerBtns = () => {
        return (
            <Fragment>
                {(parseInt(roleId) !== 16 && parseInt(roleId) !== 24) &&( 
                    <Link
                        to={`${baseUrl}/campaign-creation`}
                        className="btn btn-primary"
                        >
                        {localization.addCampaign}
                    </Link>
                )}
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger btn btn-transparent"
                >
                    <img src={Images?.Filter} alt=""/>
                    {localization.showFilters}
                </Button>
            </Fragment>
        );
    };

    const onPageChange = async (val) => {
        let filter = filterData === null ? null : filterData;
        setIsLoading(true);
        await getCampaignData(val.selected + 1, filter);
        localStorage.setItem('page', val.selected + 1)
        setIsLoading(false);
    };

    useEffect(() => {
        // console.log('ytdasfytdsa:',invoiceCreationAgainstCampaign?.status_code);
        if (
          !invoiceCreationAgainstCampaign?.status &&
          invoiceCreationAgainstCampaign?.status_code &&
          parseInt(invoiceCreationAgainstCampaign?.status_code) !== 200
        ) {
          // console.log("ffffffff");
          setIsErrorModal(true);
          setErrorMsg(invoiceCreationAgainstCampaign.message);
        } else if (
            invoiceCreationAgainstCampaign?.status_code &&
          parseInt(invoiceCreationAgainstCampaign?.status_code) === 200
        ) {
          setIsModal(true);
        }
      }, [invoiceCreationAgainstCampaign]);

    const handleInvoiceCreate = async (id) => {
        const payload = {
            campaign_id: id,
            invoice_number: formData.invoice_number
        };
        // console.log('check final payload:', payload);
        // return false;
        setIsLoading(true);
        const res = await createInvoiceForCampaign(payload);
        if(res){
            setInvoiceCreation(true);
            // await getCampaignData(val.selected + 1, filter);
        }else{
            // setInvoiceCreation(false);
        }
        setIsLoading(false);
    };

    return (
        <Layout
            title={localization.campaignList}
            Buttons={headerBtns}
            isGoback
            isLoading={isLoading}
        >
            <TableSection
                data={listData}
                isId={false}
                headers={headers}
                detailList={getCampaignListing && getCampaignListing.data}
                pageCount={pageCount}
                srNo={getCampaignListing?.from}
                onPageChange={onPageChange}
                currentPage={localStorage.getItem('page')}
                setInvoiceValidationCompletePopup={setInvoiceValidationCompletePopup}
                setCampaignId={setCampaignId}
            />

            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                CampaignListFilter={true}
            />


            <ModalPop
                title={'Add Invoice against campaign'}
                show={invoiceValidationCompletePopup}
                handleModalHide={handleApprovedModalHide}
            >
                <div className="invoice-container">
                    <div className="col-md-8">
                        <ConstantInput
                            label={localization.invoiceNumber}
                            errorMsg={localization.requiredCompanyName}
                            type="text"
                            required
                            isStarRequired={true}
                            handleChange={(value) => {
                            setFormData({ ...formData, invoice_number: value });
                            }}
                        />
                        
                    </div>
                    <div className='col-md-6 col-sm-6'>
                        <Button onClick={() => handleInvoiceCreate(campaignId)}>{'Add'}</Button>
                    </div>
                </div>
            </ModalPop>

            <ModalPop
                title={localization.conf}
                show={invoiceCreation}
                handleModalHide={handleInvoiceCreationModalHide}
                keyboard
                backdrop
            >
                <div className="text-center">
                <div className="success">
                    <img src={Images?.tick} alt="" />
                </div>
                <h5>{'Campaign Approved Successfully'}</h5>
                <a
                    className="btn btn-primary mb-4"
                    onClick={() => window.location.reload()}
                  >
                    Back to list
                  </a>
                </div>
            </ModalPop>

            <ModalPop
              title={localization.conf}
              show={isModal}
              handleModalHide={handleModalHide}
              keyboard
              backdrop
            >
              <div className="text-center">
                <div className="success">
                  <img src={Images?.tick} alt="" />
                </div>
                <h5>{"Campaign created successfully"}</h5>
                <div className="d-inline-flex">
                  <a
                    className="btn btn-primary"
                    href="campaign-list"
                    onClick={() => window.location.reload()}
                  >
                    Back to list
                  </a>
                </div>
              </div>
            </ModalPop>

            <ErrModalPop
              title={localization.error}
              show={isErrorModal}
              handleModalHide={handleModalHide1}
              keyboard
              backdrop
            >
              <div className="text-center">{errorMsg}</div>
            </ErrModalPop>
        </Layout>

        
    );
};

export default CampaignListing;
